"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Video = function Video(_ref) {
  var autoPlay = _ref.autoPlay,
      filename = _ref.filename;
  return /*#__PURE__*/_react.default.createElement("iframe", {
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    frameBorder: "0",
    loading: "lazy",
    src: "https://www.youtube.com/embed/".concat(filename).concat(autoPlay ? "?autoplay=1" : ""),
    style: {
      height: "100%",
      left: 0,
      position: "absolute",
      top: 0,
      width: "100%"
    },
    title: "ytb"
  });
};

Video.propTypes = {
  filename: _propTypes.default.string
};
var _default = Video;
exports.default = _default;